import React, { useState, useEffect } from 'react';
import {
  NavBar,
  HighlightGlobalStyle,
  ContentWrapper,
} from './Missions.styles';
import { PageContainer } from '../../components/common/PageContainer/PageContainer.styles';
import NavTabsComponent from './NavTabsComponent';
import MissionSection from './MissionSection';
import { missionSections } from './missionsData';

const Missions: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>(window.location.hash || '#compassionate-care');

  // Smooth scroll to the section based on the hash
  const scrollToSection = (sectionId: string) => {
    const targetSection = document.querySelector(sectionId);
    if (targetSection) {
      const yOffset = -120; // Adjust for sticky navbar height
      const yPosition =
        targetSection.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: yPosition,
        behavior: 'smooth',
      });
    }
  };

  // Update active tab and scroll to the section when hash changes
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash || '#compassionate-care';
      setActiveTab(hash);
      scrollToSection(hash);
    };

    handleHashChange(); // Scroll on initial load
    window.addEventListener('hashchange', handleHashChange); // Listen for hash changes
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Smooth scroll & set active tab on click
  const handleNavTabClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ) => {
    e.preventDefault();
    setActiveTab(sectionId);
    window.history.pushState(null, '', sectionId); // Update URL without reloading
    scrollToSection(sectionId);
  };

  // Update active tab on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sectionIds = missionSections.map((m) => m.id);

      for (const section of sectionIds) {
        const el = document.querySelector(section);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveTab(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <PageContainer>
      <HighlightGlobalStyle />
      <NavBar>
        <NavTabsComponent
          sections={missionSections}
          activeTab={activeTab}
          onTabClick={handleNavTabClick}
        />
      </NavBar>
      <ContentWrapper>
        {missionSections.map((section) => (
          <MissionSection key={section.id} section={section} />
        ))}
      </ContentWrapper>
    </PageContainer>
  );
};

export default Missions;
